export default function Abrechnungsdaten() {
  return (
    <div className="page-stack">
      <div>
        <p className="eyebrow">Admin</p>
        <h1 className="page-title">Abrechnungsdaten</h1>
        <p className="section-text">
          Vorbereitung fuer abrechnungsrelevante Tabellen und Importdaten.
        </p>
      </div>

      <section className="card">
        <div className="section-head">
          <div>
            <h2>Import-Tabellen</h2>
            <p className="section-text">
              Hier werden spaeter die Datensaetze aus den vorbereiteten Importen angezeigt.
            </p>
          </div>
        </div>

        <div className="empty-state">
          Noch keine Abrechnungsdaten hinterlegt.
        </div>
      </section>
    </div>
  );
}
